/* eslint-disable no-console */

import { register } from 'register-service-worker'
import { defineNuxtPlugin } from '#imports'

export function registerServiceWorker(baseURL: string) {
    if (typeof window === 'undefined') return

    register(`${baseURL}service-worker.js`, {
        ready(arg) {
            console.log(
                'App is being served from cache by a service worker.\n' +
                    'For more details, visit https://goo.gl/AFskqB'
            )
        },
        cached() {
            console.log('Content has been cached for offline use.')
        },
        updated() {
            console.log('New content is available; reloading...')
        },
        offline() {
            console.log('No internet connection found. App is running in offline mode.')
        },
        error(error) {
            console.error('Error during service worker registration:', error)
        },
        registered(reg) {
            const timeout = 5 * 60 * 1000 // check for new SW every 5 minutes
            const updateFc = () => {
                reg.update()
                setTimeout(updateFc, timeout)
            }

            setTimeout(updateFc, timeout)
        },
    })
}

export default defineNuxtPlugin({
    name: 'service-worker',
    setup(nuxtApp) {
        if (!import.meta.dev) registerServiceWorker(nuxtApp.$config.app.baseURL)
    },
})
